import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import MobileStatusChip from './mobile/MobileStatusChip'
import { MOBILE_SECTION_DIVIDER_COLOR } from './mobile/styles/mobileColors'

export default function DetailStatusMobileHeader({
  statusUI,
  fallbackStatus,
  title = 'Detalles:',
  showStatus = true
}) {
  const statusLabel = statusUI?.label || fallbackStatus || '-'

  return (
    <Box
      sx={(theme) => ({
        mt: { xs: 1.5, sm: 2 },
        mb: { xs: 1.75, sm: 2 },
        px: { xs: 1.25, sm: 1.75 },
        py: { xs: 1.2, sm: 1.4 },
        borderBottom: `1px solid ${MOBILE_SECTION_DIVIDER_COLOR}`,
        bgcolor: theme.palette.background.paper
      })}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1.5} sx={{ minWidth: 0 }}>
        <Typography
          variant="subtitle2"
          component="h3"
          sx={{
            m: 0,
            minWidth: 0,
            flex: '1 1 auto',
            fontSize: { xs: 15, sm: 16 },
            fontWeight: 500,
            lineHeight: 1.25
          }}
        >
          {title}
        </Typography>

        {showStatus && (
          <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={0.75} sx={{ flex: '0 0 auto', minWidth: 0 }}>
            <Typography component="span" sx={{ fontSize: { xs: 15, sm: 15 }, fontWeight: 500, lineHeight: 1 }}>
              Estado:
            </Typography>
            <MobileStatusChip
              statusUI={statusUI}
              label={statusLabel}
              sx={{
                maxWidth: { xs: 148, sm: 200 },
                height: { xs: 28, sm: 30 },
                fontSize: { xs: 12, sm: 13 },
                minHeight: { xs: 28, sm: 30 },
                '& .MuiChip-label': {
                  px: { xs: 1.25, sm: 1.5 },
                  whiteSpace: 'nowrap'
                }
              }}
            />
          </Stack>
        )}
      </Stack>
    </Box>
  )
}
